import { IconActionButton } from '@/components/patterns/admin-page'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { MoreVerticalIcon } from 'lucide-react'
import {
  createContext,
  useContext,
  useState,
  type Dispatch,
  type ReactElement,
  type ReactNode,
  type SetStateAction,
} from 'react'

interface ActionMenuContextValue {
  isDropdownOpen: boolean
  setIsDropdownOpen: Dispatch<SetStateAction<boolean>>
  row: unknown
}

const ActionMenuContext = createContext<ActionMenuContextValue | null>(null)

export function useActionMenu(): ActionMenuContextValue {
  const context = useContext(ActionMenuContext)
  if (context === null) {
    throw new Error('useActionMenu must be used within a ActionMenuProvider')
  }
  return context
}

const ActionsMenu = ({ row, children }: { row?: unknown; children?: ReactNode }): ReactElement => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)

  return (
    <DropdownMenu open={isDropdownOpen} onOpenChange={setIsDropdownOpen}>
      <DropdownMenuTrigger asChild>
        <IconActionButton
          icon={MoreVerticalIcon}
          label="Open menu"
          variant="ghost"
          className="flex size-8 text-muted-foreground data-[state=open]:bg-muted"
          onClick={(event) => event.stopPropagation()}
        />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" onClick={(event) => event.stopPropagation()}>
        <ActionMenuContext.Provider value={{ isDropdownOpen, setIsDropdownOpen, row }}>
          {/* This is where your actions (DropdownMenuItems) will go */}
          {children}
        </ActionMenuContext.Provider>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default ActionsMenu
